import { useEffect, useState } from "react";
import { AlertTriangle, ExternalLink } from "lucide-react";
import { toast } from "sonner";
import { api, fmtBRL } from "@/lib/api";
import { useAuth } from "@/components/auth/AuthProvider";

const BILLING_URL = "https://business.facebook.com/billing_hub/accounts/details?asset_id=1664723068335196&business_id=1336193254058797";

export const WaBillingBanner = () => {
  const { user } = useAuth();
  const [b, setB] = useState(null);
  const admin = user?.role === "admin";
  useEffect(() => {
    if (!user) return undefined;
    const load = () => api.get("/whatsapp/billing").then((r) => setB(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 600000);
    return () => clearInterval(t);
  }, [user]);
  if (!user) return null;
  if (!b?.alert) {
    return (
      <div className="mb-3 flex justify-end">
        <a data-testid="wa-billing-link" href={BILLING_URL} target="_blank" rel="noreferrer"
          className="inline-flex items-center gap-1.5 rounded-lg border border-slate-700 px-2.5 py-1 text-[11px] font-semibold text-slate-400 transition-colors hover:border-amber-400/50 hover:text-amber-200">
          Pagamento Meta (WhatsApp){b ? ` · ${fmtBRL(b.spent)} de ${fmtBRL(b.limit)}` : ""} <ExternalLink className="h-3 w-3" />
        </a>
      </div>
    );
  }

  const paid = async () => {
    if (!window.confirm("Confirmar que a fatura do WhatsApp foi paga na Meta? O contador volta para zero.")) return;
    await api.post("/whatsapp/billing/paid");
    toast.success("Contador do WhatsApp zerado");
    setB({ ...b, alert: false, spent: 0 });
  };

  return (
    <div data-testid="wa-billing-banner" className="mb-5 flex flex-wrap items-center gap-3 rounded-xl border border-amber-500/40 bg-amber-500/10 px-4 py-3 text-sm text-amber-100">
      <AlertTriangle className="h-5 w-5 shrink-0 text-amber-300" />
      <span className="min-w-0 flex-1">
        <b>Pague a Meta (WhatsApp):</b> o gasto já está em <b data-testid="wa-billing-spent">{fmtBRL(b.spent)}</b> de {fmtBRL(b.limit)}. Ao chegar no limite, a Meta tenta cobrar o cartão e, se falhar, os envios param.
      </span>
      <a data-testid="wa-billing-pay-link" href={BILLING_URL} target="_blank" rel="noreferrer"
        className="inline-flex items-center gap-1.5 rounded-lg bg-amber-400 px-3 py-1.5 text-xs font-bold text-slate-950 transition-opacity hover:opacity-90">
        Pagar na Meta <ExternalLink className="h-3.5 w-3.5" />
      </a>
      {admin && <button data-testid="wa-billing-paid-btn" onClick={paid} className="rounded-lg border border-amber-400/50 px-3 py-1.5 text-xs font-semibold text-amber-200 transition-colors hover:bg-amber-400/10">Já paguei</button>}
    </div>
  );
};
